<template>
  <el-dialog title="批量操作" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <!--名称-->
      <el-form-item label="选中数量" :label-width="formLabelWidth">
        <p class="red f20">{{ formData.ids.length || '暂无选中记录' }}</p>
      </el-form-item>

      <el-form-item label="类型" prop="required" :label-width="formLabelWidth">
        <el-select v-model="formData.type" clearable placeholder="请选择">
          <el-option label="不限" value=""></el-option>
          <el-option label="考研择校" value="1"></el-option>
          <el-option label="表单填写" value="2"></el-option>
        </el-select>
      </el-form-item>

      <!--是否必填-->
      <el-form-item label="是否必填" prop="required" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.required">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <span class="gray9 ml20">输入框必填</span>
      </el-form-item>

      <!--在详情页显示-->
      <el-form-item label="在详情页显示" prop="is_detail" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_detail">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <span class="gray9 ml20">择校显示在详情页，拟排名显示在结果页</span>
      </el-form-item>

      <!--在对比页显示-->
      <el-form-item label="在对比页显示" prop="is_contrast" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_contrast">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <span class="gray9 ml20">择校显示在对比页</span>
      </el-form-item>

      <!--是否文档导入字段-->
      <el-form-item label="导入字段" prop="is_import" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_import">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <span class="gray9 ml20">择校导入表单自动匹配</span>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--是否删除-->
      <el-form-item label="删除" prop="is_delete" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_delete">
          <el-radio label="">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading || ids.length==0">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CustomFieldApi from '@/api/study/custom_field.js';
import { alphabet } from '@/utils/base.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        ids: [],
        type: '',
        required: '',
        is_detail: '',
        is_contrast: '',
        is_import: '',
        status: '',
        is_delete: '',
      },
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'ids'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData.ids = this.ids;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if (params.ids.length<=0){
        self.$message({
          message: '暂无选中记录',
          type: 'warning'
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CustomFieldApi.batch(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/custom/field/part/Batch.vue